<template>
  <div class="section">
    <div class="section-header">
      <span class="section-number">一</span>
      <span class="section-text">社区进展</span>
    </div>
    <div class="stat-cards">
      <div class="stat-card stat-card-orange">
        <div class="stat-circle stat-circle-orange">
          <span class="stat-number">607</span>
          <span class="stat-unit">家</span>
        </div>
        <span class="stat-label">生态伙伴数</span>
      </div>
      <div class="stat-card stat-card-blue">
        <div class="stat-circle stat-circle-blue">
          <span class="stat-number">15,488</span>
          <span class="stat-unit">人</span>
        </div>
        <span class="stat-label">贡献者数</span>
      </div>
      <div class="stat-card stat-card-green">
        <div class="stat-circle stat-circle-green">
          <span class="stat-number">1,846</span>
          <span class="stat-unit">款</span>
        </div>
        <span class="stat-label">兼容性产品数</span>
      </div>
    </div>
    <summary-report-contributor dimension="all" />
    <summary-report-southbound />
    <div class="pmc-note">
      跨平台框架 PMC、具身智能 PMC 未纳入统计范围
    </div>
    <div class="section-summary">
      <div class="section-summary-title">
        <span class="section-summary-icon"><fund-outlined /></span>
        社区进展总结
      </div>
      <p>OpenHarmony PMC 外部贡献占比突破 40%，不过近两年新增贡献增长有所放缓；本月 PR 合并率 72.1%，协作重心集中在 ArkUI、文档、测试赛道。统一互联 PMC 外部贡献占比
        32.21%，有待引入更多外部伙伴深度参与共建；具身智能和跨平台框架 PMC 暂未纳入统计。</p>
    </div>
  </div>
</template>

<script setup>
import { FundOutlined } from '@ant-design/icons-vue';
import SummaryReportContributor from './SummaryReportContributor.vue';
import SummaryReportSouthbound from './SummaryReportSouthbound.vue';
</script>

<style scoped>
.section {
  margin-bottom: 32px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f0f0;
}

.section-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, #50A2FF 0%, #3B82F6 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.section-text {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  letter-spacing: 0.5px;
}

.stat-cards {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
}

.stat-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 24px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #e5e7eb;
}

.stat-card-orange {
  border-color: #ffd591;
}

.stat-card-blue {
  border-color: #91d5ff;
}

.stat-card-green {
  border-color: #95de64;
}

.stat-circle {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.stat-circle-orange {
  background: linear-gradient(135deg, #fa8c16 0%, #faad14 100%);
}

.stat-circle-blue {
  background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
}

.stat-circle-green {
  background: linear-gradient(135deg, #389e0d 0%, #52c41a 100%);
}

.stat-number {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
}

.stat-unit {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.2;
}

.stat-label {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
}

.pmc-note {
  margin-top: 24px;
  color: #9ca3af;
  font-size: 14px;
  text-align: center;
}

.section-summary {
  background: linear-gradient(135deg, #f0f7ff 0%, #f5f3ff 100%);
  border: 1px solid #c7d2fe;
  border-left: 4px solid #3b82f6;
  border-radius: 8px;
  padding: 20px 24px;
  margin-top: 24px;
  text-align: left;
}

.section-summary-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #1e3a5f;
  margin-bottom: 12px;
}

.section-summary-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: linear-gradient(135deg, #3b82f6, #6366f1);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
}

.section-summary p {
  font-size: 14px;
  line-height: 1.8;
  color: #374151;
  margin: 0;
}
</style>
